import { ProfilePicture } from "../common/ProfilePicture";
import { MobileSidebar } from "./mobile-sidebar";


export const MobileHeader = () => {
  return (
    <header className="text-sm font-semibold font-sans flex items-center justify-between border-0 border-b lg:hidden p-2 bg-white/20 backdrop-blur-md z-50">
      <a className="flex items-center" href="/">
        <img
          src="/images/nhwm_logo.png"
          alt="Logo"
          className="w-[120px] h-[30px]"
        />
      </a>
      <div className="border border-slate-300 rounded-full flex justify-center items-center">
        <MobileSidebar>
          <ProfilePicture />
        </MobileSidebar>
      </div>
    </header>
  );
};
